import React from 'react'
import styles from './Marker.module.css'
import marker from '../../Assets/locationMapa.png'
import logo from '../../Assets/logocantinho.png'

const Marker = () => {
  return (
    <div >
      <img className={styles.marker} src={marker} alt="" />
      <img className={styles.logo} src={logo} alt="" />
    </div>
  )
}

export default Marker
